module.exports = __webpack_public_path__ + "img/29-white.d4240301.svg";